import React, { useState } from "react";
import Modal from "../../../../components/ui/Modal";
import Input from "../../../../components/ui/Input";
import Button from "../../../../components/ui/Button";

const CreateCourseModal = ({ isOpen, onClose, onSave }) => {
  const [title, setTitle] = useState("");
  const [priceETB, setPriceETB] = useState("");
  const [hitLink, setHitLink] = useState("");

  const handleSaveClick = () => {
    if (!title || !priceETB || !hitLink) return;
    const newCourse = {
      id: `C-${Date.now()}`,
      title,
      priceETB: parseInt(priceETB, 10),
      hitLink,
    };
    onSave(newCourse);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Course from HIT">
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">
            Course Title
          </label>
          <Input
            placeholder="e.g., Advanced Vocal Techniques"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">
            Price (ETB)
          </label>
          <Input
            type="number"
            placeholder="e.g., 6000"
            value={priceETB}
            onChange={(e) => setPriceETB(e.target.value)}
          />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">
            Link to HIT Course
          </label>
          <Input
            placeholder="https://hit.edu/course/..."
            value={hitLink}
            onChange={(e) => setHitLink(e.target.value)}
          />
        </div>
        <div className="flex justify-end pt-4 space-x-3">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            Save Course
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateCourseModal;
